import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

const CategoryDropdown = ({ value, onChange, categories = [], placeholder = "Select Category" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedCategory = categories.find((cat) => String(cat.id) === String(value));
  const selectedLabel = selectedCategory ? (selectedCategory.translations?.en?.name || selectedCategory.name) : placeholder;

  return (
    <div ref={containerRef} className="relative w-full">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full border border-gray-300 bg-white rounded-lg px-3 h-[42px] mt-1 text-sm flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 transition-all duration-200 hover:border-gray-400"
      >
        <span className="truncate">{selectedLabel}</span>
        <FaChevronDown className={`text-gray-400 text-xs transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <ul className="absolute z-50 w-full bg-white border border-gray-200 rounded-lg shadow-lg mt-1 max-h-[185px] overflow-y-auto py-1 animate-fadeIn">
          <li
            onClick={() => {
              onChange("");
              setIsOpen(false);
            }}
            className="px-3 py-2.5 text-sm text-gray-500 hover:bg-gray-50 cursor-pointer transition-colors duration-150"
          >
            {placeholder}
          </li>
          {categories.map((cat) => {
            const label = cat.translations?.en?.name || cat.name;
            const isSelected = String(cat.id) === String(value);
            return (
              <li
                key={cat.id}
                onClick={() => {
                  onChange(cat.id);
                  setIsOpen(false);
                }}
                className={`px-3 py-2.5 text-sm cursor-pointer transition-colors duration-150 flex items-center justify-between ${
                  isSelected ? "bg-blue-50 text-blue-600 font-semibold" : "text-gray-700 hover:bg-gray-50"
                }`}
              >
                <span className="truncate">{label}</span>
                {isSelected && <span className="text-blue-600 text-xs font-bold">✓</span>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CategoryDropdown;
